import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import BankDetails from './pages/BankDetails';
import RedeemCash from './pages/RedeemCash';
import ScrollToTop from './utils/ScrollToTop';
import UpiPage from './pages/UpiPage';
import UpiConfirmPage from './pages/UpiConfirmPage';
import Signup from './pages/Signup';
import BackButtonHandler from './components/BackButtonHandler';
import useAutoLogout from './utils/useAutoLogout.js';
import useOnlineStatus from './hooks/useOnlineStatus';
import ProtectedRoute from './utils/ProtectedRoute';
import PublicRoute from './utils/PublicRoute';
import NotFound from './pages/NotFound';
import Profile from './pages/Profile';
import Language from './pages/Language';
import SloganPage from './pages/SloganPage';
import Transactions from './pages/Transactions';
import { Toaster } from "react-hot-toast";
import ScanPage from './pages/ScanPage';
import ProfileSetup from './pages/ProfileSetup';
import ProfileSetupRoute from './utils/ProfileSetupRoute';
import { getT } from './i18n/translations';
import Spin from './pages/Spin';
import History from './pages/History';
import { Giftcard } from './pages/Giftcard';

function App() {

  useAutoLogout(30);
  useEffect(() => {
    const t = getT();
    document.title = t.appTitle;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", t.appDescription);
  }, []);
  const isOnline = useOnlineStatus();
  return (
    <div className="App">
      {!isOnline && (
        <div className="fixed top-0 w-full bg-red-600 text-white text-center py-2 shadow-lg z-[9999]">
          📡 You are offline
        </div>
      )}
      <BrowserRouter>
        <BackButtonHandler />
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<PublicRoute><Language /></PublicRoute>} />
            <Route path="/:code" element={<PublicRoute><Language /></PublicRoute>} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            {/* <Route path="/sign-up" element={<PublicRoute><Signup /></PublicRoute>} /> */}
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/slogan" element={<ProtectedRoute><SloganPage /></ProtectedRoute>} />

            <Route path="/bank-details" element={<ProtectedRoute><BankDetails /></ProtectedRoute>} />
            <Route path="/redeem-cash" element={<ProtectedRoute><RedeemCash /></ProtectedRoute>} />
            <Route path="/upi-details" element={<ProtectedRoute><UpiPage /></ProtectedRoute>} />
            <Route path="/upi-confirm" element={<ProtectedRoute><UpiConfirmPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route
              path="/profile-setup"
              element={
                <ProfileSetupRoute>
                  <ProfileSetup />
                </ProfileSetupRoute>
              }
            />
            <Route path="/scan" element={<ProtectedRoute><ScanPage /></ProtectedRoute>} />
            <Route path="/spin" element={<ProtectedRoute><Spin /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
            <Route path="/gift-card" element={<ProtectedRoute><Giftcard /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 5000,
          style: {
            borderRadius: "10px",
            background: "#1a2e1a",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
